export default function Services() {
  const services = [
    {
      icon: 'ri-scales-3-line',
      title: 'Defensa Penal',
      description: 'Representación legal experta en casos penales de cualquier complejidad. Defensa estratégica basada en años de experiencia en el sistema judicial.',
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Asesoría Corporativa',
      description: 'Consultoría legal para empresas en cumplimiento normativo, prevención de delitos corporativos y gestión de riesgos legales.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Litigios Civiles',
      description: 'Representación en disputas civiles, contratos, responsabilidad civil y resolución de conflictos mediante negociación o litigio.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Delitos Económicos',
      description: 'Especialización en casos de fraude, lavado de dinero, corrupción y otros delitos financieros complejos.',
    },
    {
      icon: 'ri-team-line',
      title: 'Derecho Laboral',
      description: 'Asesoramiento en conflictos laborales, despidos, negociaciones colectivas y protección de derechos de trabajadores.',
    },
    {
      icon: 'ri-home-line',
      title: 'Derecho de Familia',
      description: 'Asistencia legal en divorcios, custodia de menores, pensiones alimenticias y otros asuntos familiares.',
    },
  ];

  return (
    <section id="servicios" className="py-24 lg:py-32 bg-amber-50/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Header */}
        <div className="mb-16">
          <div className="inline-block px-4 py-2 bg-navy/10 rounded-full mb-6">
            <span className="text-navy text-sm font-semibold uppercase tracking-wide">Áreas de Práctica</span>
          </div>
          <h2 className="font-serif font-extrabold text-5xl lg:text-6xl text-gray-900 leading-tight max-w-3xl">
            Servicios Legales Especializados
          </h2>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              {/* Icon */}
              <div className="w-14 h-14 flex items-center justify-center mb-6">
                <i className={`${service.icon} text-5xl text-navy group-hover:text-gold transition-colors`}></i>
              </div>

              {/* Title */}
              <h3 className="font-serif font-semibold text-2xl text-gray-900 mb-4">
                {service.title}
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 text-base mb-6">
            ¿No encuentra el servicio que necesita? Contácteme para discutir su caso específico.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('contacto');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="px-8 py-3 bg-navy text-white text-sm font-semibold rounded-full hover:bg-navy-light transition-all whitespace-nowrap cursor-pointer"
          >
            Consulta Gratuita
          </button>
        </div>
      </div>
    </section>
  );
}
